import '../../../../assets/css/screens/admin/dashboard/adminnotification/AdminNotification.css';
import axios from 'axios';
import NotificationSkeleton from "../../../../components/skeltonloading/NotificationSkeleton";
import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Calendar, DollarSign, CheckCircle, AlertTriangle, MessageSquare, Bell } from 'lucide-react';
import AppContext from '../../../../context/AppContext';
import echo from '../../../../config/echo';


// ── Icon + color config per type ──────────────────────────────
const TYPE_CONFIG = {
  booking: { icon: <Calendar size={20} />, iconColor: '#0491e1', iconBg: '#e8f4fd' },
  bid: { icon: <CheckCircle size={20} />, iconColor: '#10b981', iconBg: '#e6f9f2' },
  payment: { icon: <DollarSign size={20} />, iconColor: '#10b981', iconBg: '#e6f9f2' },
  reminder: { icon: <Bell size={20} />, iconColor: '#f59e0b', iconBg: '#fff7e6' },
  wallet: { icon: <AlertTriangle size={20} />, iconColor: '#ef4444', iconBg: '#fef2f2' },
  message: { icon: <MessageSquare size={20} />, iconColor: '#0491e1', iconBg: '#e8f4fd' },
};

const AdminNotification = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const { baseUrl, authToken } = useContext(AppContext);
  const adminId = localStorage.getItem("subadminId");
  const navigate = useNavigate();
  const handleMarkRead = async (id) => {

    try {

      const res = await axios.post(
        `${baseUrl}/admin/mark/as/read/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${authToken}`
          }
        }
      );


      console.log(res.data);


      setNotifications(prev =>
        prev.map(item =>
          item.id === id
            ? { ...item, status: "read" }
            : item
        )
      );


    } catch (error) {

      console.log(error.response?.data);

    }

  }

  const handleBack = () => navigate(-1);

  const fetchNotifications = () => {

  setLoading(true);

  axios.get(`${baseUrl}/admin/notification`, {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  })
  .then((response) => {

    setNotifications(response.data.notifications);

  })
  .catch((error) => {

    console.log(error);

  })
  .finally(() => {

    setLoading(false);

  });

};

  useEffect(() => {
    fetchNotifications();
  }, []);
  useEffect(() => {

    if (!adminId) {
        console.log("Subadmin ID not found");
        return;
    }

    console.log(
        "Joining Admin Notification Channel:",
        `admin-${adminId}`
    );

    const channel = echo.channel(`admin-${adminId}`);

    channel.subscribed(() => {
        console.log("Admin Notification Channel Joined");
    });

    channel.listen(".NotificationUpdates", (event) => {

        console.log("Admin Notification Socket Event:", event);

        if (!event.notification) {
            return;
        }

        setNotifications(prev => {

            // Duplicate notification prevent
            if (
                prev.some(
                    notification => notification.id === event.notification.id
                )
            ) {
                return prev;
            }

            return [
                event.notification,
                ...prev
            ];

        });

    });

    return () => {

        console.log(
            "Leaving Admin Notification Channel:",
            `admin-${adminId}`
        );

        echo.leave(`admin-${adminId}`);

    };

}, [adminId]);

  if (loading) {
  return (
    <>
      
      <NotificationSkeleton />
    </>
  );
}



  // clear
  const handleClearAll = async () => {

  try {

    const res = await axios.post(
      `${baseUrl}/admin/notifications/clear`,
      {},
      {
        headers:{
          Authorization:`Bearer ${authToken}`
        }
      }
    );


    console.log(res.data);


    setNotifications([]);


  } catch(error){

    console.log(error.response?.data);

  }

};

  return (
  <div className="wn-page">

    {/* ════ MOBILE HEADER ════ */}
  <div className="wn-mob-header">

  <button
    className="wn-back-btn"
    onClick={handleBack}
  >
    <ArrowLeft size={22} />
  </button>


  <h2 className="wn-heading">
    Notifications
  </h2>


  <button
    className="wn-clear-btn"
    onClick={handleClearAll}
  >
    Clear All
  </button>

</div>

    {/* ════ NOTIFICATIONS LIST ════ */}
    <div className="wn-list">

      {loading ? (
<NotificationSkeleton />

      ) : notifications.length === 0 ? (

        <div className="wn-empty-box">

          <div className="wn-empty-icon">
            <Bell size={45} />
          </div>

          <h3>No Notifications</h3>

          <p>
            You don't have any notifications yet.
          </p>

        </div>

      ) : (

        notifications.map((notif, index) => {

          const cfg = TYPE_CONFIG[notif.type] || {
            icon: <Bell size={20} />,
            iconColor: "#0491e1",
            iconBg: "#e8f4fd"
          };

          return (

            <div
              key={notif.id}
              className={`wn-card${notif.status !== "read" ? " wn-card--unread" : ""}`}
              style={{
                animationDelay: `${index * 0.06}s`
              }}
              onClick={() => handleMarkRead(notif.id)}
            >

              <div
                className="wn-icon"
                style={{
                  background: cfg.iconBg,
                  color: cfg.iconColor
                }}
              >
                {cfg.icon}
              </div>

              <div className="wn-content">

                <p className="wn-title">
                  {notif.title}
                </p>

                <p className="wn-message">
                  {notif.description}
                </p>

                <span className="wn-time">
                  {new Date(notif.created_at).toLocaleString()}
                </span>

              </div>

              {notif.status !== "read" && (
                <span className="wn-dot"></span>
              )}

            </div>

          );

        })

      )}

    </div>

  </div>
);
  

};

export default AdminNotification;